<template>
  <div id="app">
    <div
      id="nav"
      class="header-panel"
      :class="$route.params.name ? 'inner-head' : ''"
    >
      <header class="main-header">
        <span class="back-btn"
          ><img src="./assets/images/arrow-w.svg" alt="" @click="back"
        /></span>

        <span class="logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="147.982"
            height="62.834"
            viewBox="0 0 147.982 62.834"
          >
            <g transform="translate(-113.53 -375.083)">
              <g transform="translate(113.53 369.583)">
                <path
                  fill="#0a4e9e"
                  class="a1"
                  d="M17.645,23.681c-.326,0-1.011.07-1.046.7L2,60.637v1.282c0,.941-.06,1.282.725,1.282h57.4a3.256,3.256,0,0,0,3.142-2.325L76.375,24.731V23.82Z"
                  transform="translate(0.564 5.133)"
                />
                <path
                  fill="#0a4e9e"
                  d="M16.325,26.017h52.92V17.98a3.507,3.507,0,0,0-3.5-3.5H34L27.589,5.5H3.5A3.508,3.508,0,0,0,0,9V62.6L13.185,28.34A3.254,3.254,0,0,1,16.325,26.017Z"
                />
              </g>
              <g transform="translate(30.991 -116.744)">
                <path
                  fill="#0a4e9e"
                  d="M7.977,11.559a11.083,11.083,0,0,0,4.545-.926A12.3,12.3,0,0,0,16.26,8.058a15.6,15.6,0,0,0,3.5-5.353,16.886,16.886,0,0,0,1.212-6.262,12.476,12.476,0,0,0-.623-4.276,7.824,7.824,0,0,0-1.8-2.862,6.577,6.577,0,0,0-2.761-1.6,11.425,11.425,0,0,0-3.4-.522,10.112,10.112,0,0,0-3.838.724,9.65,9.65,0,0,0-3.1,1.986A9.34,9.34,0,0,0,3.382-7.143a8.792,8.792,0,0,0-.758,3.619A6.872,6.872,0,0,0,3.2-.628,6.046,6.046,0,0,0,4.745,1.459,6.523,6.523,0,0,0,7.018,2.721,8.942,8.942,0,0,0,9.8,3.142a8.227,8.227,0,0,0,3.131-.589A6.672,6.672,0,0,0,15.149,1.19a9.524,9.524,0,0,1-2.289,3.827,6.271,6.271,0,0,1-4.612,1.93A6.134,6.134,0,0,1,5.57,6.391,10.678,10.678,0,0,1,3.264,4.859L.234,8.584A11.9,11.9,0,0,0,3.8,10.79,11.292,11.292,0,0,0,7.977,11.559ZM11.445-1.032a4.008,4.008,0,0,1-2.592-.812,2.858,2.858,0,0,1-1.01-2.367,4.229,4.229,0,0,1,.32-1.624A4.047,4.047,0,0,1,9.088-7.2a4.386,4.386,0,0,1,1.448-.93,5.016,5.016,0,0,1,1.885-.338,3.721,3.721,0,0,1,2.761,1.015,2.734,2.734,0,0,1,.623,1,3.531,3.531,0,0,1,.219,1.235A4.1,4.1,0,0,1,15.7-3.62a3.915,3.915,0,0,1-.926,1.336,4.533,4.533,0,0,1-1.448.913A5.016,5.016,0,0,1,11.445-1.032Zm13.2,12.188H29.76L36.123-12.58H32.588l-7.407,2.054.067,4.41,4.276-.976Z"
                  transform="translate(194.398 540.039)"
                />
                <path
                  fill="#0a4e9e"
                  d="M44.832,6.139h0a6.212,6.212,0,0,0,1.661,4.242q1.626,1.777,5.341,1.777H62.266V12.15a.269.269,0,0,1,.009-.045q.009-.036.036-.125t.063-.241q.036-.152.107-.393t.161-.6q.089-.357.223-.831t.3-1.1q.17-.625.366-1.429H54.406q-2.3,0-3.09-1.34a4.157,4.157,0,0,1-.5-2.929A5.584,5.584,0,0,1,52.8-.122a5.482,5.482,0,0,1,3.3-1.009h3.68v.009a.146.146,0,0,1-.009.036q-.009.027-.027.107t-.054.223q-.036.143-.1.357t-.143.527q-.08.313-.188.741H55.853a3.32,3.32,0,0,0-2.4,1.4A2.588,2.588,0,0,0,53.1,4.4a1.683,1.683,0,0,0,1.465,1.241h5.395a5.105,5.105,0,0,0,3.153-1.027,4.769,4.769,0,0,0,1.8-2.742V1.861a.156.156,0,0,1,.018-.045.571.571,0,0,0,.036-.134,2.755,2.755,0,0,1,.071-.277q.054-.179.125-.447T65.338.3q.107-.393.25-.929a4.221,4.221,0,0,0-.848-3.84,4.488,4.488,0,0,0-3.671-1.679H56.71A12.37,12.37,0,0,0,48.3-2.533,11.634,11.634,0,0,0,44.832,6.139Zm19.953,6.02h0L65.8,7.193h9.414q1.5.125,1.8-.929Q77.056,5.1,75.288,5.21H72.644a5.358,5.358,0,0,1-4.207-1.768,5.47,5.47,0,0,1-.9-4.734q1.59-5.216,8.02-4.841h9.9L84.4-1.363H74.662q-1.107-.054-1.268.8a.749.749,0,0,0,.473.875,3.62,3.62,0,0,0,1.492.161L77.735.405q3.34.107,4.421,1.885a6.809,6.809,0,0,1,.581,4.743q-1.107,5.323-7.342,5.127Z"
                  transform="translate(107 539)"
                />
                <path
                  fill="#ffffff"
                  d="M-4.771,12.159H1.087L3.16,2.924h9.7l1.179-5.466H4.392L5.107-5.7A.884.884,0,0,1,5.4-6.133a.656.656,0,0,1,.4-.161H10.43v-.018H20l1.25-5.466H4.8q-3.7,0-5.073,3.966Zm22.364-.375h0a1.615,1.615,0,0,1-.2.375h6.038a2.585,2.585,0,0,0,.107-.375L27.828-6.24H21.88ZM22.237-7.83h5.948l.893-3.948H23.13ZM27.381,5.925h0a5.132,5.132,0,0,0,.956,4.359,4.705,4.705,0,0,0,3.921,1.876h4.073L37.6,7.1H34.348a.927.927,0,0,1-.777-.357,1.088,1.088,0,0,1-.223-.822l4.448-17.7H31.829Z"
                  transform="translate(107 539)"
                />
              </g>
            </g>
          </svg>
        </span>

        <span class="profile-img">
          <img
            v-if="getUserInfo.user_image !== ''"
            :src="getUserInfo.user_image"
          />
          <!-- <h1>{{getUserInfo.name}}</h1> -->
          <img
            src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
            alt=""
          />
        </span>
      </header>
      <div class="search-box">
        <label for="search"
          ><img src="./assets/images/ic_search.svg" alt="" @click="search"
        /></label>
          <!-- v-model="searchfile" -->
        <input
          type="text"
          :placeholder="$t('Search')"
          id="search"
          @keyup="handleSearch($event.target.value)"
        />
      </div>
        <loader91 v-if="isLoading"></loader91>

      <!-- <router-link to="/about">About</router-link> -->
    </div>
    <router-view />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { SessionHelper, LANG } from './utils/session';
export default {
  data() {
    return {
      // user_image: {},
      searchfile: '',
      isLoading: false
    };
  },

  computed: {
    ...mapGetters([
      'getUserInfo',
      'getFolderPath',
      'getUserFile',
      'getUserFileData',
      'getUserFolderData',
    ]),
  },
  async mounted() {
    // SessionHelper.setCookie('JWT-TOKEN', 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI4MzQ5MzUxNzEyIiwiWC1BdXRoLUlEIjoiYjNmMDQzNjZiNzJhMDk5MTNjNDMyYjBjMmExMjY2ZDkiLCJpYXQiOjE1OTc4MjY5NDcsImV4cCI6MTU5NzgyNzg0N30.BIN0PUESqUP0hCFX3-hHNQSf_n_NDwP0PeVXIiq_ZyA')
    this.$i18n.locale = SessionHelper.getCookie(LANG) || 'hi';
    await this.userProfile()
  }, 
  methods: {
    userProfile(){
      this.$store.dispatch({
        type: 'getUserProfile',
      }).catch((err)=>{
        if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            //this.userProfile()
          }
        }
      })
    },
    async userFile() {
      let file_id = '';
      if (this.$route.params.name !== undefined) {
        let file_id_string = this.$route.params.name.split('/');
        file_id = file_id_string[file_id_string.length - 1];
      }
      await this.$store
        .dispatch('userFile', {
          headers: {
            'folder-id': file_id,
            Limit: 0,
          },
        })
        .then((response) => {
          this.$store.commit('setUserFile', response);
          this.$store.commit('setUserFolderData', response.folder);
          this.$store.commit('setUserFileData', response.Data);
          this.loading = false
        })
        .catch((err)=>{
        if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.userFile()
          }
        }
      })
    },
    handleSearch(newVal) {
      if (newVal.length) {
        this.isLoading = true
        this.search(newVal);
        this.$store.commit('setSearchValue', true);
      } else {
        this.isLoading = false
        this.userFile();
        this.$store.commit('setSearchValue', false);
      }
      // if (newVal.length) {
      //   var fileValue = this.getUserFileData.filter((obj) => {
      //     return obj.data_name.toLowerCase().includes(newVal.toLowerCase());
      //   });
      //   console.log('==fileValuefileValue=',fileValue)
      //   if(fileValue.length){
      //     this.$store.commit("setUserFileData", fileValue);
      //   }else{
      //     console.log('=else=')
      //     this.search(newVal)
      //   }
      //   var folderValue = this.getUserFolderData.filter((obj) => {
      //     return obj.folder_name.toLowerCase().includes(newVal.toLowerCase());
      //   });
      //   console.log('==folderValuefolderValue=',folderValue)
      //   if(folderValue.length){
      //     this.$store.commit("setUserFolderData", folderValue);
      //   }else{
      //     console.log('=else===2')
      //     this.search(newVal)
      //   }
      // } else {
      //   this.$store.commit("setUserFileData", this.getUserFile.Data);
      //   this.$store.commit("setUserFolderData", this.getUserFile.folder);
      // }
    },
    search(value) {
      this.$store
        .dispatch({
          type: 'search',
          payload: {
            search: value,
          },
        })
        .then((data) => {
          console.log('data: ', data);
          this.$store.commit('setUserFileData', data.data);
          this.$store.commit('setUserFolderData', data.folder);
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          if((err.response.data.message === 'Token is expired!') || (err.response.data.message === 'Invalid token.')){
          SessionHelper.refereshJwtToken();
          if (SessionHelper.getCookie('JWT-TOKEN') !== 'null') {
            this.search()
          }
        }
        });
    },
    back: function() {
      this.$router.go(-1);
      // this.$store.commit('setSearchValue', false);
      // this.$store.commit('NameNavigationRoute', 'remove'); 
    },
  },
};
</script>
